import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import LoginModal from '../LoginModal';
import UserOffCanvas from './UserOffCanvas';
import IconProfile from '../icons/IconProfile';
import domainModel from 'domain-model';

const { isPrivabShop } = domainModel.shopConfig;

const UserButton = ({ sessionUser, toggleLoginModal, shopConfig }) => {
  const isLoggedIn = !_.isEmpty(sessionUser);

  const [isUserOffCanvasOpen, setIsUserOffCanvasOpen] = useState(false);
  const toggleUserOffCanvas = () => {
    setIsUserOffCanvasOpen(!isUserOffCanvasOpen);
  };
  return (
    <>
      {isLoggedIn && (
        <>
          <Button
            id="UserButton"
            onClick={isLoggedIn ? toggleUserOffCanvas : toggleLoginModal}
            className="p-0 list-inline-item position-relative ms-2"
            name="profile"
            color="none"
            style={{ width: '30px', height: '30px' }}
          >
            {sessionUser && (
              <IconProfile
                fill="dark"
                stroke={isPrivabShop(shopConfig) ? 'white' : 'black'}
              />
            )}
          </Button>

          {!isLoggedIn && <LoginModal />}
          {isLoggedIn && (
            <UserOffCanvas
              isOpen={isUserOffCanvasOpen}
              toggle={toggleUserOffCanvas}
            />
          )}
        </>
      )}
    </>
  );
};

UserButton.propTypes = {
  sessionUser: PropTypes.object,
  toggleLoginModal: PropTypes.func.isRequired,
};
UserButton.defaultProps = {
  sessionUser: null,
};

export default connect(({ authentication, shopConfig }) => ({
  sessionUser: authentication.sessionUser,
  shopConfig,
}))(UserButton);
